import { SectionIconsType } from '@/components/ui/custom/material/slides/sections/view/SectionIcon';
import { DEFAULT_EDITORJS_DATA } from '@/data/hook/editorjs/useEditorJS';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { OutputData } from '@editorjs/editorjs';
import { t } from 'i18next';
import Chapter from './Chapter';

export type bookType = 'STUDENT' | 'TEACHER';

export enum MaterialType {
  SLIDE = 'SLIDE',
  TEXT = 'TEXT',
}

export default interface Book {
  id: number;
  filename: string;
  uploadedAt: string;
  chapters: Chapter[];
  verion: number;
  status: VersioningStatusEnum;
  bookType: bookType;
  materialType: MaterialType;
}

export enum BookUploadStatusEnum {
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export type BookUploadStatus = {
  id: number;
  bookId: number;
  status: BookUploadStatusEnum;
  createdAt: string;
  updatedAt: string;
};

export class Section {
  id: number = 0;
  chapterItemId: number = 0;
  title: string = t('section.title');
  content: OutputData = DEFAULT_EDITORJS_DATA;
  icon: SectionIconsType = 'AcademicCapIcon';
  order: number = 0;
  startsHidden: boolean = false;
  instructions: string | null = null;
  editing?: boolean;
  activitiesIds: number[] = [];

  constructor(init?: Partial<Section>) {
    Object.assign(this, init);
  }
}

export type OptimizedBook = {
  id: number;
  bookStyle: BookStyleEnum;
};

// TODO: Remove this enum and use MaterialTypeEnum instead
export enum BookStyleEnum {
  TEXT = 'TEXT',
  APRESENTATION = 'APRESENTATION',
}
